const article = {
    slug: "first_yohji_yamamoto_experience",
    category: "BRAND ENTRY",
    title: "初めてのYOHJI YAMAMOTOをレンタル体験",
    listDescription:
      "黒、余白、反骨、ドレープ。YOHJI YAMAMOTOを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのYOHJI YAMAMOTOをレンタル体験｜ヨウジヤマモトを着て知るEnclopedia",
      description:
        "YOHJI YAMAMOTOが気になるけれど、どんなブランドか分からない方へ。山本耀司の生い立ち、黒、ドレープ、オーバーサイズ、Yohji Yamamoto POUR HOMME、Y's、Ground Y、北野武映画『BROTHER』の衣装文脈まで分かりやすく解説し、Enclopediaでレンタルできるアーカイブへ案内します。",
      keyword:
        "初めてのYOHJI YAMAMOTO,YOHJI YAMAMOTO 初めて,ヨウジヤマモト 初めて,YOHJI YAMAMOTO とは,ヨウジヤマモト どんなブランド,YOHJI YAMAMOTO レンタル,ヨウジヤマモト レンタル,YOHJI YAMAMOTO アーカイブ,ヨウジヤマモト アーカイブ,Yohji Yamamoto POUR HOMME,ヨウジヤマモトプールオム,Y's レンタル,Ground Y レンタル,ヨウジヤマモト 黒,ヨウジヤマモト ドレープ,ヨウジヤマモト 北野武,BROTHER 衣装 ヨウジヤマモト,ヤクザスーツ,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_yohji_yamamoto_experience",
    },
    hero: {
      label: "FIRST YOHJI YAMAMOTO EXPERIENCE",
      number: "10 / ENTRY",
      titleLines: ["初めての", "YOHJI YAMAMOTOをレンタル体験。"],
      body:
        "YOHJI YAMAMOTOは、\n黒い服のブランドとしてだけでは語れません。\n余白、ドレープ、身体を締めつけない分量、そして社会の美意識に対する静かな反抗。\n初めて知るなら、まずは“着ることで分かる黒の色気と余白”から入るのが自然です。",
      keywords: [
        "first experience",
        "black",
        "drape",
        "yohji yamamoto",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["黒を着るのではなく、", "余白と反骨をまとう。"],
      image: "media/archive_fashion/archive_guide10.png",
      imageAlt:
        "初めてのYOHJI YAMAMOTOをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるYOHJI YAMAMOTOを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/YOHJI%20YAMAMOTO（ヨウジヤマモト）/?number=71",
    },
    thesis: {
      text:
        "YOHJI YAMAMOTOは、身体を飾るのではなく、身体を守り、隠し、余白によって存在感を立ち上げるブランドです。",
      keywords: ["black", "space", "rebellion"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "YOHJI YAMAMOTOが気になる。",
          "でも、黒い服の何が特別なのか分からない。",
        ],
        body:
          "YOHJI YAMAMOTOは、“黒くて大きい服”という印象で語られがちです。\nしかし、その黒は単なる色ではありません。\n身体を隠すための黒、社会の美意識に抵抗する黒、動いたときに影を生む黒。\nこのページでは、ヨウジヤマモトを“雰囲気のあるモード服”ではなく、山本耀司の生い立ち、反骨性、映画衣装の色気まで含めて、着て理解するためのブランドとして整理します。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "父を失った戦後の記憶と、",
          "母の洋裁店から生まれた服。",
        ],
        body:
          "山本耀司は1943年、東京に生まれました。\n父を戦争で亡くし、戦後に働く母の姿を見て育ったことは、彼の服作りを語る上で欠かせない背景です。\n慶應義塾大学で法律を学んだ後、母の洋裁店を手伝い、さらに文化服装学院で服作りを学びます。\nその出発点には、流行を作ることよりも、身体を守ること、既存の女性らしさ・男性らしさに抗うこと、そして人間の弱さや強さを服で受け止める感覚があります。",
        knowledgeItems: [
          {
            title: "黒は、悲しみではなく意志の色。",
            text:
              "ヨウジの黒は、無難な黒ではありません。社会が求める華やかさや分かりやすい美しさに対して、黙って距離を取るための色です。",
          },
          {
            title: "大きな服は、身体を隠すためだけではない。",
            text:
              "オーバーサイズのジャケットやコートは、身体を覆いながら、同時に着る人の存在感を大きく見せます。守ることと強く見せることが同時に起きます。",
          },
          {
            title: "ドレープは、布が人間に寄り添う線。",
            text:
              "身体にぴったり沿わせるのではなく、布が落ち、揺れ、余る。そこに人間の弱さ、色気、動きが出ます。",
          },
          {
            title: "北野武映画のスーツは、ヨウジの色気が分かる入口。",
            text:
              "映画『BROTHER』のヤクザスーツは、単に怖い衣装ではありません。黒いスーツ、余った布、肩の強さ、静かな緊張感が、暴力よりも色気として残ります。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE YOHJI?",
        titleLines: [
          "YOHJI YAMAMOTOを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "BLACK",
            text:
              "黒を単なる色ではなく、陰影、反骨、距離感として見る。ヨウジヤマモトを理解する最初の視点です。",
          },
          {
            tag: "ENTRY 02",
            title: "DRAPE & SPACE",
            text:
              "身体に密着させるのではなく、布と身体の間に余白を作る。そこに動きと色気が生まれます。",
          },
          {
            tag: "ENTRY 03",
            title: "POUR HOMME / Y's",
            text:
              "POUR HOMMEはメンズの強い造形、Y'sは日常に近い実用性と反骨性が魅力。入口の違いを知ると選びやすくなります。",
          },
          {
            tag: "ENTRY 04",
            title: "CINEMA & SUITS",
            text:
              "北野武映画『BROTHER』の衣装のように、ヨウジのスーツは物語の中で人間の危うさと色気を強く引き出します。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "YOHJI YAMAMOTOは、写真で見るよりも、実際に着たときの布の落ち方、黒の奥行き、身体との距離で理解が深まるブランドです。",
        items: [
          {
            index: "01",
            title: "黒なのに、重く見えすぎない理由",
            text:
              "同じ黒でも、ウールギャバジン、レーヨン、コットン、リネンでは光の拾い方が違います。実物では、黒の中にある陰影の幅が見えます。",
          },
          {
            index: "02",
            title: "大きい服なのに、だらしなく見えない理由",
            text:
              "ヨウジのオーバーサイズは、ただサイズが大きいだけではありません。肩、背中、裾、布の落ち方が計算されているため、余白が緊張感に変わります。",
          },
          {
            index: "03",
            title: "スーツが、社会性ではなく色気になる",
            text:
              "普通のスーツは整えるための服です。ヨウジのスーツは、少し崩れ、布が余り、影を作ることで、着る人の危うさや色気を引き出します。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "黒は隠すための色であり、",
          "存在を強くするための色でもある。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: [
          "初めてのYOHJI YAMAMOTOほど、",
          "レンタルで理解が深まる。",
        ],
        items: [
          {
            number: "01",
            title: "写真では、黒の質感が伝わりきらない",
            text:
              "黒い服は写真で差が出にくいですが、実物では素材の厚み、光沢、落ち感、陰影が大きく違います。",
          },
          {
            number: "02",
            title: "サイズ感と余白を確かめられる",
            text:
              "ヨウジヤマモトは分量が大きい服が多く、サイズ表だけでは判断しにくいブランドです。着ることで余白の意味が分かります。",
          },
          {
            number: "03",
            title: "“似合うか不安”を体験に変えられる",
            text:
              "黒、ドレープ、オーバーサイズは強く見えますが、実際に着ると身体を受け止めてくれる感覚があります。レンタルはその距離を縮める入口になります。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるYOHJI YAMAMOTO。"],
        body:
          "実在庫への導線は、“YOHJI YAMAMOTOを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "Y's for men / 2023AW",
            title: "テーラードジャケット",
            text:
              "再始動したY's for menの文脈を持つ2023AW。Yohjiらしい黒の余白と実用服の落ち着きを、端正なテーラードの形で体験できる一着。",
            href:
              "https://www.enclopedia-official.com/product/b267d829-0236-4588-9bbf-ed5f3f376fba",
            image:
              "media/product/1762345150.0142834b267d829-0236-4588-9bbf-ed5f3f376fba.jpg",
          },
          {
            meta: "YOHJI YAMAMOTO POUR HOMME / 2022SS",
            title: "釈迦釦 長袖シャツ",
            text:
              "2022SSの、光と影、過去のアーカイブ、シュルレアリスムやワークウェアの要素が交差する文脈を背景にしたシャツ。釈迦釦の存在感が、黒の静けさに象徴性を加えます。",
            href:
              "https://www.enclopedia-official.com/product/7f645c4b-4726-40e7-9cc0-cb8f2c4058be",
            image:
              "media/product/1756906703.2119977f645c4b-4726-40e7-9cc0-cb8f2c4058be.jpg",
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "YOHJI YAMAMOTOは、どんなブランドですか？",
            answer:
              "黒、ドレープ、オーバーサイズ、非対称なカッティングを通じて、身体に余白と存在感を与えるブランドです。既存の美しさや性別の見え方に対する反骨性も特徴です。",
          },
          {
            question: "Yohji Yamamoto POUR HOMMEとY'sは違いますか？",
            answer:
              "はい。POUR HOMMEはメンズのコレクション性が強く、Y'sはより日常に近い実用性と反骨性を持つラインとして理解できます。",
          },
          {
            question: "北野武の映画『BROTHER』と関係がありますか？",
            answer:
              "はい。映画『BROTHER』では山本耀司が衣装デザインを手がけており、黒いスーツやヤクザスタイルの静かな色気を知る上で、ヨウジヤマモトの魅力が分かりやすい文脈です。",
          },
          {
            question: "初めてなら、どのアイテムから見るのがおすすめですか？",
            answer:
              "黒いジャケット、ワイドパンツ、ロングシャツ、ドレープのあるコートなど、ヨウジらしい余白と布の落ち方が分かるアイテムがおすすめです。",
          },
          {
            question: "写真と実物で印象は変わりますか？",
            answer:
              "大きく変わります。黒の質感、布の重さ、ドレープ、肩や裾の余白は、実物で着ると最も理解しやすい要素です。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのYOHJI YAMAMOTOを、",
          "レンタルから始める。",
        ],
        body:
          "黒、余白、ドレープ、反骨、そして映画のような色気。\nEnclopediaで、YOHJI YAMAMOTOのアーカイブを体験してください。",
        buttonLabel: "レンタルできるYOHJI YAMAMOTOを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/YOHJI%20YAMAMOTO（ヨウジヤマモト）/?number=71",
      },
    },
  };

export default article;
